export const coworkerTransform = x => ({
  ...x,
  value: x.id,
  name: x.email,
  // we can't loose name, because we display it, but "name" is used for filtering and that is done by email
  fullName: x.name,
})
